import {
    useEffect,
    useState
} from "react";

import API from "../../services/api";
import toast from "react-hot-toast";

function Settings() {

    const [form,
        setForm] =
        useState({
            company_name: "",
            company_email: "",
            company_phone: "",
            company_address: "",
            gst_number: "",
            invoice_prefix: "",
            invoice_footer: ""
        });

    const [logo,
        setLogo] =
        useState(null);

    const [preview,
        setPreview] =
        useState("");

    useEffect(() => {
        loadSettings();
    }, []);

    const loadSettings =
        async () => {

            try {

                const res =
                    await API.get(
                        "/settings"
                    );

                setForm({
                    company_name:
                        res.data.company_name || "",

                    company_email:
                        res.data.company_email || "",

                    company_phone:
                        res.data.company_phone || "",

                    company_address:
                        res.data.company_address || "",

                    gst_number:
                        res.data.gst_number || "",

                    invoice_prefix:
                        res.data.invoice_prefix || "",

                    invoice_footer:
                        res.data.invoice_footer || ""
                });

                if (
                    res.data.logo
                ) {

                    setPreview(
                        `${process.env.REACT_APP_API_URL}/uploads/${res.data.logo}`
                    );

                }

            } catch (err) {

                console.log(err);

            }

        };

    const submit =
        async (e) => {

            e.preventDefault();

            try {

                const data =
                    new FormData();

                Object.keys(form)
                    .forEach(
                        key => {
                            data.append(
                                key,
                                form[key]
                            );
                        }
                    );

                if (logo) {

                    data.append(
                        "logo",
                        logo
                    );

                }

                await API.put(
                    "/settings",
                    data
                );

                toast.success("Settings Updated");

            } catch (err) {

                console.log(err);

            }

        };

    return (
        <div>

            <h1
                className="
                text-4xl
                font-bold
                mb-6
                "
            >
                Company Settings
            </h1>

            <form
                onSubmit={submit}
                className="
                bg-[#111]
                rounded-2xl
                p-6
                "
            >

                <div
                    className="
                    grid
                    md:grid-cols-2
                    gap-5
                    "
                >

                    <input
                        placeholder="Company Name"
                        value={
                            form.company_name
                        }
                        onChange={(e)=>
                            setForm({
                                ...form,
                                company_name:
                                    e.target.value
                            })
                        }
                        className="
                        p-3
                        rounded-xl
                        bg-black
                        "
                    />

                    <input
                        placeholder="Company Email"
                        value={
                            form.company_email
                        }
                        onChange={(e)=>
                            setForm({
                                ...form,
                                company_email:
                                    e.target.value
                            })
                        }
                        className="
                        p-3
                        rounded-xl
                        bg-black
                        "
                    />

                    <input
                        placeholder="Company Phone"
                        value={
                            form.company_phone
                        }
                        onChange={(e)=>
                            setForm({
                                ...form,
                                company_phone:
                                    e.target.value
                            })
                        }
                        className="
                        p-3
                        rounded-xl
                        bg-black
                        "
                    />

                    <input
                        placeholder="GST Number"
                        value={
                            form.gst_number
                        }
                        onChange={(e)=>
                            setForm({
                                ...form,
                                gst_number:
                                    e.target.value
                            })
                        }
                        className="
                        p-3
                        rounded-xl
                        bg-black
                        "
                    />

                    <input
                        placeholder="Invoice Prefix"
                        value={
                            form.invoice_prefix
                        }
                        onChange={(e)=>
                            setForm({
                                ...form,
                                invoice_prefix:
                                    e.target.value
                            })
                        }
                        className="
                        p-3
                        rounded-xl
                        bg-black
                        "
                    />

                    <input
                        type="file"
                        onChange={(e)=>{

                            setLogo(
                                e.target.files[0]
                            );

                            setPreview(
                                URL.createObjectURL(
                                    e.target.files[0]
                                )
                            );

                        }}
                        className="
                        p-3
                        rounded-xl
                        bg-black
                        "
                    />

                </div>

                <textarea
                    rows="4"
                    placeholder="Company Address"
                    value={
                        form.company_address
                    }
                    onChange={(e)=>
                        setForm({
                            ...form,
                            company_address:
                                e.target.value
                        })
                    }
                    className="
                    w-full
                    mt-5
                    p-3
                    rounded-xl
                    bg-black
                    "
                />

                <textarea
                    rows="4"
                    placeholder="Invoice Footer"
                    value={
                        form.invoice_footer
                    }
                    onChange={(e)=>
                        setForm({
                            ...form,
                            invoice_footer:
                                e.target.value
                        })
                    }
                    className="
                    w-full
                    mt-5
                    p-3
                    rounded-xl
                    bg-black
                    "
                />

                {preview && (

                    <img
                        src={preview}
                        alt=""
                        className="
                        w-32
                        h-32
                        object-cover
                        rounded-xl
                        mt-5
                        "
                    />

                )}

                <button
                    type="submit"
                    className="
                    mt-6
                    px-6
                    py-3
                    bg-yellow-500
                    text-black
                    rounded-xl
                    font-semibold
                    "
                >
                    Save Settings
                </button>

            </form>

        </div>
    );
}

export default Settings;